// src/api/helpers.js
import { api } from 'src/utils/newAxios';

export async function makePost(path, payload = {}, opts = {}) {
  try {
    const { data } = await api.post(path, payload);

    if (data?.success !== true) {
      const err = new Error(data?.message || "Une erreur s'est produite, veuillez contacter l'administrateur.");
      err.code = data?.code || 'API_ERROR';
      throw err;
    }

    // ⬇️ On renvoie la réponse telle quelle (message, data, etc.)
    return data;

  } catch (error) {
    // 401/419 gérés par l’intercepteur → code = AUTH_REQUIRED
    if (error?.code === 'AUTH_REQUIRED' && typeof opts.onAuthRequired === 'function') {
      await opts.onAuthRequired();
    }
    throw error; // NETWORK, API_ERROR, etc.
  }
}

export async function makeGet(path, opts = {}) {
  try {
    const { data } = await api.get(path);

    if (data?.success !== true) {
      const err = new Error(data?.message || "Une erreur s'est produite, veuillez contacter l'administrateur.");
      err.code = data?.code || 'API_ERROR';
      throw err;
    }

    return data;

  } catch (error) {
    if (error?.code === 'AUTH_REQUIRED' && typeof opts?.onAuthRequired === 'function') {
      await opts?.onAuthRequired();
    }
    throw error;
  }
}

export async function makeDelete(path, opts = {}) {
  try {
    const { data } = await api.delete(path);

    if (data?.success !== true) {
      const err = new Error(data?.message || "Une erreur s'est produite, veuillez contacter l'administrateur.");
      err.code = data?.code || 'API_ERROR';
      throw err;
    }

    return data;

  } catch (error) {
    if (error?.code === 'AUTH_REQUIRED' && typeof opts?.onAuthRequired === 'function') {
      await opts?.onAuthRequired();
    }
    throw error;
  }
}

export async function uploadImage(path, payload = {}, opts = {}) {

  try {
    const { data } = await api.post(path, payload, {
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: (event) => {
        if (event.total && typeof opts.onProgress === 'function') {
          const progress = Math.round((event.loaded * 100) / event.total);
          opts.onProgress(progress);
        }
      },
      cancelToken: opts.cancelToken, // optionnel si tu veux annuler l’upload
    });

    if (data?.success !== true) {
      const err = new Error(
        data?.message ||
          "Une erreur s'est produite, veuillez contacter l'administrateur."
      );
      err.code = data?.code || 'API_ERROR';
      throw err;
    }

    // On renvoie les mêmes infos que makePost
    return data; // { success: true, data: ..., message: ... }

  } catch (error) {
    // si ton intercepteur axios met error.code = 'AUTH_REQUIRED'
    if (
      error?.code === 'AUTH_REQUIRED' &&
      typeof opts.onAuthRequired === 'function'
    ) {
      await opts.onAuthRequired();
    }

    // Tu peux aussi ajouter un callback d’erreur UI si tu veux
    if (typeof opts.onError === 'function') {
      opts.onError(error);
    }

    throw error;
  }
}


